import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { tickerFormatter } from '../../utils/charts-common.js';

const MonthlyOverspeeds = ({ chartData, grouping, intl }) => (
  <ResponsiveContainer debounce={1000}>
    <BarChart
      data={chartData}
      margin={{
           top: 5, right: 30, left: 20, bottom: 5,
          }}
    >
      <CartesianGrid strokeDasharray="3 3" vertical={false} />
      <XAxis
        dataKey="group"
        tickFormatter={tickerFormatter(intl)(grouping)}
      />
      <YAxis
        label={{
              value: intl.formatMessage({ id: 'stats.charts.numberOfOverspeeds' }),
              angle: -90,
              position: 'insideBottomLeft',
            }}
      />
      <Tooltip labelFormatter={tickerFormatter(intl)(grouping)} />
      <Bar dataKey="overspeeds" fill="#4D6E85" name={intl.formatMessage({ id: 'stats.charts.numberOfOverspeeds' })} />
    </BarChart>
  </ResponsiveContainer>
);
MonthlyOverspeeds.propTypes = {
  intl: intlShape.isRequired,
  chartData: PropTypes.array.isRequired,
  grouping: PropTypes.string.isRequired,
};

export default injectIntl(MonthlyOverspeeds);



// WEBPACK FOOTER //
// ./src/components/Stats/MonthlyOverspeeds.js